export default "__VITE_ASSET__D7k1n4MI__"